import { useMediaQuery } from '@mui/material';

import theme from '../Components/defaultTheme';

const useIsMobile = () => useMediaQuery(theme.breakpoints.down('md'));

export { useIsMobile };
